import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEllipsis } from "react-icons/fa6";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";


const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();


    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const isHomePage = location.pathname === "/";

    const handleNavClick = (sectionId) => {
        if (isHomePage) {
            const element = document.getElementById(sectionId);
            element?.scrollIntoView({ behavior: 'smooth' });
        } else {
            navigate(`/`);

            setTimeout(() => {
                const element = document.getElementById(sectionId);
                element?.scrollIntoView({ behavior: 'smooth' });
            }, 100); // 100ms bekle

        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            setIsScrolled(scrollTop > 100); // 100px scroll sonrası arkaplan gelsin
        };

        window.addEventListener('scroll', handleScroll);

        // Component unmount olduğunda event listener'ı temizle
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        element.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>

            <header className={`py-4 fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[#252525] text-white' : 'bg-transparent text-white'

                }`}>
                <div className="container max-w-7xl flex items-center mx-auto px-4 justify-between">
                    {/* Logo */}
                    <div className="flex-shrink-0 bg sm:items-center cursor-pointer" onClick={() => handleNavClick('home')}>
                        <img src="/Images/zenon-white-logo.png" alt="Zenon Logo" className="h-10" />
                    </div>

                    {/* Navigation Menu */}
                    <nav className="hidden md:flex absolute left-1/2  -translate-x-1/2 flex justify-center space-x-8 font-montserrat font-bold">
                        <button onClick={() => handleNavClick('home')} className="hover:text-[#ad2831] transition-colors ">Ana Sayfa</button>
                        <button onClick={() => handleNavClick('products')} className="hover:text-[#ad2831] transition-colors ">Ürünler</button>
                        <button onClick={() => handleNavClick('about')} className="hover:text-[#ad2831] transition-colors ">Hakkımızda</button>
                        <button onClick={() => handleNavClick('where-to-buy')} className="hover:text-[#ad2831] transition-colors ">Nereden Alınır</button>
                        <button onClick={() => handleNavClick('contact')} className="hover:text-[#ad2831] transition-colors ">Bize Ulaşın</button>
                    </nav>

                    <button
                        onClick={toggleMenu}
                        className="md:hidden flex flex-col text-white justify-center items-center  text-4xl"
                    >
                        <FiChevronLeft />
                    </button>

                </div>
            </header>

            <div className={`md:hidden fixed inset-0 bg-black bg-opacity-95 z-50 flex flex-col items-center justify-center space-y-8 transition-all duration-300 ${isMenuOpen
                ? 'translate-x-0 opacity-100'
                : 'translate-x-full opacity-0 pointer-events-none'
                }`}>
                <button className="absolute text-white right-4 top-4 text-4xl" onClick={() => toggleMenu()}><FiChevronRight /></button>
                <div className="flex flex-col items-center font-montserrat font-bold">
                    <button className="text-white text-2xl hover:text-[#ad2831] transition-colors" onClick={() => { handleNavClick('home'); toggleMenu(); }} >Anasayfa</button>
                </div>
                <div className="flex flex-col items-center font-montserrat font-bold">
                    <button className="text-white text-2xl hover:text-[#ad2831] transition-colors" onClick={() => { handleNavClick('products'); toggleMenu(); }} >Ürünler</button>
                </div>
                <div className="flex flex-col items-center font-montserrat font-bold">
                    <button className="text-white text-2xl hover:text-[#ad2831] transition-colors" onClick={() => { handleNavClick('about'); toggleMenu(); }} >Hakkımızda</button>
                </div>
                <div className="flex flex-col items-center font-montserrat font-bold">
                    <button className="text-white text-2xl hover:text-[#ad2831] transition-colors" onClick={() => { handleNavClick('where-to-buy'); toggleMenu(); }} >Nereden Alınır</button>
                </div>
                <div className="flex flex-col items-center font-montserrat font-bold">
                    <button className="text-white text-2xl hover:text-[#ad2831] transition-colors" onClick={() => { handleNavClick('contact'); toggleMenu(); }} >Bize Ulaşın</button>
                </div>
            </div>

        </>
    );
};

export default Header;